export default "__VITE_ASSET__5vw7g$7Z__"